import script from "./GBPPostFix.vue?vue&type=script&setup=true&lang=js"
export * from "./GBPPostFix.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__